import {PathwaysModeling} from '../../../commands/pathways-modeling';
import EventBus from 'diagram-js/lib/core/EventBus';
import {RemoveConnectionHandler} from '../../../commands/remove-connection-handler';
import {TreeNavigator} from '@ispm/shared/bpmn-io/services/tree-navigator';
import {FloatingNodesService} from '@ispm/shared/bpmn-io/services/floating-nodes-service';
import {isEmpty} from 'lodash';
import {ModelingUtil} from "@ispm/shared/bpmn-io/modeling-util";
import {connection} from '@ispm-shared/modules/bpmn/diagram-element-terms';
import {State} from "@ispm-client/modules/bpmn-modeler/store/state";
import {Store} from "@ngrx/store";

export class MarkConnectionDeletedHandler extends RemoveConnectionHandler {

  constructor(pathwaysModeling: PathwaysModeling, eventBus: EventBus, treeNavigator: TreeNavigator, floatingNodesService: FloatingNodesService,store$: Store<State>) {
    super(pathwaysModeling, eventBus, floatingNodesService, store$);
  }

  postExecute(context): any {
    const elementsToRemove = context.elementsToRemove;
    if (!isEmpty(elementsToRemove)) {
      const connectionToRemove = elementsToRemove.find((element) => ModelingUtil.getElementType(element) === connection);
      this.updateDirectTreeAfterRemovingConnection(connectionToRemove);
      this.updateParentCondition(connectionToRemove);
    }
  }
}
